import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import NonMembersPopup from '../components/NonMembersPopup';
import useMoveTo from '../constants/navigation';
import { ROUTES } from '../App';

let externalShowNonMembers = () => console.warn('NonMembersPopupProvider not mounted');
let externalHideNonMembers = () => { };

export const showNonMembersPopup = () => externalShowNonMembers();
export const hideNonMembersPopup = () => externalHideNonMembers();

const NonMembersPopupContext = createContext({ show: () => { }, hide: () => { } });

export const NonMembersPopupProvider = ({ children }) => {
    const [open, setOpen] = useState(false);
    const navigate = useMoveTo();

    const hide = useCallback(() => { setOpen(false); }, []);
    const show = useCallback(() => { setOpen(true); }, []);

    useEffect(() => {
        externalShowNonMembers = show;
        externalHideNonMembers = hide;
    }, [show, hide]);

    return (
        <NonMembersPopupContext.Provider value={{ show, hide }}>
            {children}
            {open && (
                <NonMembersPopup
                    open={open}
                    onUpgrade={() => {
                        hide();
                        navigate(ROUTES.SUBSCRIPTION_PLAN);
                    }}
                    onClose={hide}
                />
            )}
        </NonMembersPopupContext.Provider>
    );
};

export const useNonMembersPopup = () => useContext(NonMembersPopupContext);
